//const { forEach } = require("lodash");

var app = angular.module('galibos');

app.controller('galibosController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'galibosService', 'infraestructurasService', 'authenticationInfo', 'authenticationService',
    function ($rootScope, $scope, $location, $route, $routeParams, galibosService, infraestructurasService, authenticationInfo, authenticationService) {

        var myChart;
        var myChart2;

        $scope.authentication = authenticationInfo;
        $scope.rol = authenticationInfo.rol;
        $scope.usuario = $rootScope.usuario;
        $scope.descargaActiva = true;

        $scope.pestanyavisible = 'datosentrada';

        //VARIABLES PARA EL CONTORNO CINEMATICO DE REFERENCIA

        //var CCRefh1 = 0.4;
        //var CCRefh2 = 1.15;
        //var CCRefh3 = 1.15;
        //var CCRefh4 = 3.32;
        //var CCRefh5 = 3.32;
        //var CCRefh6 = 3.32;
        //var CCRefh7 = 4.545;


        //var CCRefb1 = 1.695;
        //var CCRefb2 = 1.695;
        //var CCRefb3 = 1.72;
        //var CCRefb4 = 1.72;
        //var CCRefb5 = 1.72;
        //var CCRefb6 = 1.72;
        //var CCRefb7 = 1.49;

        var b = 1.695;
        $scope.b = b;
        $scope.k = 0;
        $scope.S_0 = 0.4;




        galibosService.getEstadoBalasto()
            .then(function (response) {
                $scope.estadosbalasto = response.data;
            });

        galibosService.getContornos()
            .then(function (response) {
                var data = response.data;
                $scope.contornos = data;
            });

        galibosService.getTipoAnden()
            .then(function (response) {
                var data = response.data;
                $scope.tiposAndenes = data;
            });

        galibosService.getCatenarias()
            .then(function (response) {
                var data = response.data;
                $scope.catenarias = data;
            });

        galibosService.getDisimetrias()
            .then(function (response) {
                var data = response.data;
                $scope.disimetrias = data;
            });

        galibosService.getDesplazamientosVerticalesVia()
            .then(function (response) {
                var data = response.data;
                $scope.desplazamientosVerticalesVia = data;
            });

        galibosService.getVelocidadDesviacionPeralte()
            .then(function (response) {
                var data = response.data;
                $scope.velocidadesDesviacionPeralte = data;
            });

        $scope.imprimirAnejo = function () {

            var elemento = document.getElementById('loader-seguimiento');
            elemento.style.display = 'block';

            galibosService.getDesplazamientosLateralesVerticales($scope.Contorno.Id, $scope.ContornoInferior.Id, $scope.DesplazamientoVerticalVia.Id, $scope.Rv,
                $scope.datosparametrizables.M3balto, $scope.datosparametrizables.M3bbajo, $scope.datosparametrizables.M3halto,
                $scope.datosparametrizables.M3hbajo,
                $scope.EstadoBalasto.Descripcion, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id, $scope.datosparametrizables.I0,
                $scope.I, $scope.D, $scope.datosparametrizables.D0, $scope.datosparametrizables.L, $scope.R, $scope.datosparametrizables.lmax, $scope.datosparametrizables.hc0, $scope.AnchoVia.Id)

                .then(function (response) {
                    $scope.galiboVerticalHorizontal = response.data;
                    //alert('Cálculo de desplazamientos laterales verticales completado');

                    galibosService.getGaliboAnden($scope.Tension.Id, $scope.tipoAnden.Id, $scope.bordeInt, $scope.bordeExt, $scope.Tq, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id,
                        $scope.I, $scope.datosparametrizables.I0, $scope.datosparametrizables.L, $scope.D, $scope.datosparametrizables.D0, $scope.R, $scope.datosparametrizables.lmax,
                        $scope.EstadoBalasto.Descripcion,
                        $scope.datosparametrizables.hc0, b, $scope.AnchoVia.Id, $scope.Hcrmin, $scope.Hnez)

                        .then(function (response) {
                            $scope.galiboAnden = response.data;
                            //alert('Cálculo de gálibo andén completado');

                            galibosService.getDesplazamientosNominal($scope.Tension.Id, $scope.Contorno.Id, $scope.ContornoInferior.Id, $scope.DesplazamientoVerticalVia.Id, $scope.Rv,
                                $scope.datosparametrizables.M3balto, $scope.datosparametrizables.M3bbajo, $scope.datosparametrizables.M3halto,
                                $scope.datosparametrizables.M3hbajo,
                                $scope.EstadoBalasto.Descripcion, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id, $scope.datosparametrizables.I0,
                                $scope.I, $scope.D, $scope.datosparametrizables.D0, $scope.datosparametrizables.L, $scope.R, $scope.datosparametrizables.lmax, $scope.datosparametrizables.hc0, $scope.Pantografo.Id,
                                $scope.catenaria.Id, $scope.datosparametrizables.pant_cw, $scope.datosparametrizables.pant_hf, $scope.datosparametrizables.pant_ho, $scope.datosparametrizables.pant_hu,
                                $scope.datosparametrizables.pant_epo, $scope.datosparametrizables.pant_epu, $scope.datosparametrizables.pant_I0, $scope.datosparametrizables.pant_Do, $scope.AnchoVia.Id)

                                .then(function (response) {
                                    $scope.galiboNominal = response.data;
                                    //alert('Cálculo de desplazamiento nominal completado');

                                    // $scope.imprimir = function () {

                                    var datosentrada = new Object();

                                    datosentrada.ContornoInferior = $scope.ContornoInferior.Id;
                                    datosentrada.AnchoVia = $scope.AnchoVia.Id;
                                    datosentrada.Contorno = $scope.Contorno.Id;
                                    datosentrada.R = $scope.R;
                                    datosentrada.D = $scope.D;
                                    datosentrada.I = $scope.I;
                                    datosentrada.TD = $scope.TD;
                                    datosentrada.TN = $scope.TN;
                                    datosentrada.Rv = $scope.Rv;
                                    datosentrada.EstadoBalasto = $scope.EstadoBalasto.Descripcion;
                                    datosentrada.Pantografo = $scope.Pantografo.Id;
                                    datosentrada.Tension = $scope.Tension.Id;
                                    datosentrada.catenaria = $scope.catenaria.Id;

                                    $scope.datosentrada = datosentrada;

                                    var formDataTexto = new FormData();
                                    formDataTexto.append("galiboVerticalHorizontal", JSON.stringify($scope.galiboVerticalHorizontal));
                                    formDataTexto.append("galiboNominal", JSON.stringify($scope.galiboNominal));
                                    formDataTexto.append("galiboAnden", JSON.stringify($scope.galiboAnden));

                                    //     galibosService.imprimir($scope.datosentrada, $scope.datosparametrizables, $scope.galiboVerticalHorizontal, $scope.galiboNominal, $scope.galiboAnden)

                                    galibosService.imprimirAnejo($scope.datosentrada, $scope.datosparametrizables, formDataTexto)
                                        .then(function (data, status, headers) {
                                            var filename = 'Documento Adjunto para Galibos.doc';
                                            var contentType = 'application/msword';

                                            var blob = new Blob([data.data],
                                                { type: contentType });

                                            if (navigator.appVersion.toString().indexOf('.NET') > 0) //IE
                                                window.navigator.msSaveBlob(blob, filename);
                                            else //Resto
                                            {
                                                var downloadLink = document.createElement("a");
                                                var url = window.URL.createObjectURL(blob);
                                                downloadLink.setAttribute("target", "_blank");
                                                downloadLink.setAttribute("href", url);
                                                downloadLink.setAttribute("download", filename);
                                                document.body.appendChild(downloadLink);
                                                downloadLink.click();
                                                document.body.removeChild(downloadLink);
                                                elemento.style.display = 'none';
                                            }

                                        })



                                });


                        });



                });
        }


        $scope.imprimirCalculos = function () {

            var elemento = document.getElementById('loader-seguimiento');
            elemento.style.display = 'block';

            galibosService.getDesplazamientosLateralesVerticales($scope.Contorno.Id, $scope.ContornoInferior.Id, $scope.DesplazamientoVerticalVia.Id, $scope.Rv,
                $scope.datosparametrizables.M3balto, $scope.datosparametrizables.M3bbajo, $scope.datosparametrizables.M3halto,
                $scope.datosparametrizables.M3hbajo,
                $scope.EstadoBalasto.Descripcion, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id, $scope.datosparametrizables.I0,
                $scope.I, $scope.D, $scope.datosparametrizables.D0, $scope.datosparametrizables.L, $scope.R, $scope.datosparametrizables.lmax, $scope.datosparametrizables.hc0, $scope.AnchoVia.Id)

                .then(function (response) {
                    $scope.galiboVerticalHorizontal = response.data;
                    //alert('Cálculo de desplazamientos laterales verticales completado');

                    galibosService.getGaliboAnden($scope.Tension.Id, $scope.tipoAnden.Id, $scope.bordeInt, $scope.bordeExt, $scope.Tq, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id,
                        $scope.I, $scope.datosparametrizables.I0, $scope.datosparametrizables.L, $scope.D, $scope.datosparametrizables.D0, $scope.R, $scope.datosparametrizables.lmax,
                        $scope.EstadoBalasto.Descripcion,
                        $scope.datosparametrizables.hc0, b, $scope.AnchoVia.Id, $scope.Hcrmin, $scope.Hnez)

                        .then(function (response) {
                            $scope.galiboAnden = response.data;
                            //alert('Cálculo de gálibo andén completado');

                            galibosService.getDesplazamientosNominal($scope.Tension.Id, $scope.Contorno.Id, $scope.ContornoInferior.Id, $scope.DesplazamientoVerticalVia.Id, $scope.Rv,
                                $scope.datosparametrizables.M3balto, $scope.datosparametrizables.M3bbajo, $scope.datosparametrizables.M3halto,
                                $scope.datosparametrizables.M3hbajo,
                                $scope.EstadoBalasto.Descripcion, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id, $scope.datosparametrizables.I0,
                                $scope.I, $scope.D, $scope.datosparametrizables.D0, $scope.datosparametrizables.L, $scope.R, $scope.datosparametrizables.lmax, $scope.datosparametrizables.hc0, $scope.Pantografo.Id,
                                $scope.catenaria.Id, $scope.datosparametrizables.pant_cw, $scope.datosparametrizables.pant_hf, $scope.datosparametrizables.pant_ho, $scope.datosparametrizables.pant_hu,
                                $scope.datosparametrizables.pant_epo, $scope.datosparametrizables.pant_epu, $scope.datosparametrizables.pant_I0, $scope.datosparametrizables.pant_Do, $scope.AnchoVia.Id)

                                .then(function (response) {
                                    $scope.galiboNominal = response.data;
                                    //alert('Cálculo de desplazamiento nominal completado');

                                    // $scope.imprimir = function () {

                                    var datosentrada = new Object();

                                    datosentrada.ContornoInferior = $scope.ContornoInferior.Id;
                                    datosentrada.AnchoVia = $scope.AnchoVia.Id;
                                    datosentrada.Contorno = $scope.Contorno.Id;
                                    datosentrada.R = $scope.R;
                                    datosentrada.D = $scope.D;
                                    datosentrada.I = $scope.I;
                                    datosentrada.TD = $scope.TD;
                                    datosentrada.TN = $scope.TN;
                                    datosentrada.Rv = $scope.Rv;
                                    datosentrada.EstadoBalasto = $scope.EstadoBalasto.Descripcion;
                                    datosentrada.Pantografo = $scope.Pantografo.Id;
                                    datosentrada.Tension = $scope.Tension.Id;
                                    datosentrada.catenaria = $scope.catenaria.Id;

                                    $scope.datosentrada = datosentrada;

                                    var datosEntradaAnden = new Object();
                                    datosEntradaAnden.Hcrmin = $scope.Hcrmin;
                                    datosEntradaAnden.Hnez = $scope.Hnez;
                                    datosEntradaAnden.Tq = $scope.Tq;
                                    datosEntradaAnden.tipoAnden = $scope.tipoAnden.Id;
                                    datosEntradaAnden.BordeInt = $scope.bordeInt;
                                    datosEntradaAnden.BordeExt = $scope.bordeExt;
                                    datosEntradaAnden.tension = $scope.Tension.Id
                                    datosEntradaAnden.Pantografo = $scope.Pantografo.Id;
                                    datosEntradaAnden.pant_cw = $scope.datosparametrizables.pant_cw;
                                    datosEntradaAnden.pant_hf = $scope.datosparametrizables.pant_hf;
                                    datosEntradaAnden.pant_ho = $scope.datosparametrizables.pant_ho;
                                    datosEntradaAnden.pant_hu = $scope.datosparametrizables.pant_hu;
                                    datosEntradaAnden.pant_epo = $scope.datosparametrizables.pant_epo;
                                    datosEntradaAnden.pant_epu = $scope.datosparametrizables.pant_epu;
                                    datosEntradaAnden.pant_IO = $scope.datosparametrizables.pant_IO;
                                    datosEntradaAnden.pant_Do = $scope.datosparametrizables.pant_Do;

                                    $scope.datosEntradaAnden = datosEntradaAnden;

                                    var formDataTexto = new FormData();
                                    formDataTexto.append("galiboVerticalHorizontal", JSON.stringify($scope.galiboVerticalHorizontal));
                                    formDataTexto.append("galiboNominal", JSON.stringify($scope.galiboNominal));
                                    formDataTexto.append("galiboAnden", JSON.stringify($scope.galiboAnden));

                                    //     galibosService.imprimir($scope.datosentrada, $scope.datosparametrizables, $scope.galiboVerticalHorizontal, $scope.galiboNominal, $scope.galiboAnden)

                                    galibosService.imprimirCalculos($scope.datosentrada, $scope.datosparametrizables, $scope.datosEntradaAnden, formDataTexto)
                                        .then(function (data, status, headers) {
                                            var filename = 'Documento Datos para Galibos.xlsx';
                                            var contentType = 'application/vnd.ms-excel';

                                            var blob = new Blob([data.data],
                                                { type: contentType });

                                            if (navigator.appVersion.toString().indexOf('.NET') > 0) //IE
                                                window.navigator.msSaveBlob(blob, filename);
                                            else //Resto
                                            {
                                                var downloadLink = document.createElement("a");
                                                var url = window.URL.createObjectURL(blob);
                                                downloadLink.setAttribute("target", "_blank");
                                                downloadLink.setAttribute("href", url);
                                                downloadLink.setAttribute("download", filename);
                                                document.body.appendChild(downloadLink);
                                                downloadLink.click();
                                                document.body.removeChild(downloadLink);
                                                elemento.style.display = 'none';
                                            }

                                        })



                                });


                        });



                });
        }


        $scope.calcular = function () {

            var elemento = document.getElementById('loader-seguimiento');
            elemento.style.display = 'block';

            galibosService.getDesplazamientosLateralesVerticales($scope.Contorno.Id, $scope.ContornoInferior.Id, $scope.DesplazamientoVerticalVia.Id, $scope.Rv,
                $scope.datosparametrizables.M3balto, $scope.datosparametrizables.M3bbajo, $scope.datosparametrizables.M3halto,
                $scope.datosparametrizables.M3hbajo,
                $scope.EstadoBalasto.Descripcion, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id, $scope.datosparametrizables.I0,
                $scope.I, $scope.D, $scope.datosparametrizables.D0, $scope.datosparametrizables.L, $scope.R, $scope.datosparametrizables.lmax, $scope.datosparametrizables.hc0, $scope.AnchoVia.Id)

                .then(function (response) {
                    $scope.galiboVerticalHorizontal = response.data;

                    galibosService.getGaliboAnden($scope.Tension.Id, $scope.tipoAnden.Id, $scope.bordeInt, $scope.bordeExt, $scope.Tq, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id,
                        $scope.I, $scope.datosparametrizables.I0, $scope.datosparametrizables.L, $scope.D, $scope.datosparametrizables.D0, $scope.R, $scope.datosparametrizables.lmax,
                        $scope.EstadoBalasto.Descripcion,
                        $scope.datosparametrizables.hc0, b, $scope.AnchoVia.Id, $scope.Hcrmin, $scope.Hnez)

                        .then(function (response) {
                            $scope.galiboAnden = response.data;

                            //alert('Cálculo de gálibo andén completado')
                        });

                    galibosService.getDesplazamientosNominal($scope.Tension.Id, $scope.Contorno.Id, $scope.ContornoInferior.Id, $scope.DesplazamientoVerticalVia.Id, $scope.Rv,
                        $scope.datosparametrizables.M3balto, $scope.datosparametrizables.M3bbajo, $scope.datosparametrizables.M3halto,
                        $scope.datosparametrizables.M3hbajo,
                        $scope.EstadoBalasto.Descripcion, $scope.Disimetria.Id, $scope.VelocidadDesviacionPeralte.Id, $scope.datosparametrizables.I0,
                        $scope.I, $scope.D, $scope.datosparametrizables.D0, $scope.datosparametrizables.L, $scope.R, $scope.datosparametrizables.lmax, $scope.datosparametrizables.hc0, $scope.Pantografo.Id,
                        $scope.catenaria.Id, $scope.datosparametrizables.pant_cw, $scope.datosparametrizables.pant_hf, $scope.datosparametrizables.pant_ho, $scope.datosparametrizables.pant_hu,
                        $scope.datosparametrizables.pant_epo, $scope.datosparametrizables.pant_epu, $scope.datosparametrizables.pant_I0, $scope.datosparametrizables.pant_Do, $scope.AnchoVia.Id)

                        .then(function (response) {
                            $scope.galiboNominal = response.data;
                            //alert('Cálculo de desplazamiento nominal completado')

                            var formDataTexto = new FormData();
                            formDataTexto.append("galiboVerticalHorizontal", JSON.stringify($scope.galiboVerticalHorizontal));
                            formDataTexto.append("galiboNominal", JSON.stringify($scope.galiboNominal));
                            formDataTexto.append("galiboAnden", JSON.stringify($scope.galiboAnden));


                            //Dibujo Grafico Limite
                            if (myChart) {
                                myChart.destroy();
                            }

                            const ctx = document.getElementById('graficoLimite').getContext('2d');
                            myChart = new Chart(ctx, {
                                type: 'scatter', // Tipo de gráfico
                                data: {
                                    datasets: [{
                                        label: 'GaliboEnvolventeInt', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[0], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[1], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[2], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[3], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[4], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[5], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[6], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[6] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntB[7], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeIntH[7] }
                                        ],
                                        borderColor: 'rgba(255, 99, 132, 1)', // Color de la línea Rojo
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'GaliboEnvolventeExt', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[0], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[1], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[2], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[3], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[4], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[5], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[6], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[6] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtB[7], y: $scope.galiboVerticalHorizontal.galibo.listaGaliboEnvolventeExtH[7] }
                                        ],
                                        borderColor: 'rgba(54, 162, 235, 1)', // Color de la línea Azul
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'VmaxIntBmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntBmaxH[6] }
                                        ],
                                        borderColor: 'rgba(255, 159, 64, 1)', // Color de la línea Naranja
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'VmaxIntHmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxIntHmaxH[6] }
                                        ],
                                        borderColor: 'rgba(255, 206, 86, 1)', // Color de la línea Amarillo
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'VmaxExtBmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtBmaxH[6] }
                                        ],
                                        borderColor: 'rgba(75, 192, 192, 1)', // Color de la línea Verde Claro
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'VmaxExtHmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaVmaxExtHmaxH[6] }
                                        ],
                                        borderColor: 'rgba(201, 203, 207, 1)', // Color de la línea Gris
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'V0IntBmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntBmaxH[6] }
                                        ],
                                        borderColor: 'rgba(255, 99, 71, 1)', // Color de la línea Tomate (Rojo claro)
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'V0IntHmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaV0IntHmaxH[6] }
                                        ],
                                        borderColor: 'rgba(30, 144, 255, 1)', // Color de la línea Azul Dodger
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'V0ExtBmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtBmaxH[6] }
                                        ],
                                        borderColor: 'rgba(60, 179, 113, 1)', // Color de la línea Verde marino medio
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    },
                                    {
                                        label: 'V0ExtHmax', // Etiqueta del conjunto de datos
                                        data: [
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxB[0], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxH[0] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxB[1], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxH[1] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxB[2], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxH[2] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxB[3], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxH[3] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxB[4], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxH[4] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxB[5], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxH[5] },
                                            { x: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxB[6], y: $scope.galiboVerticalHorizontal.galibo.listaV0ExtHmaxH[6] }
                                        ],
                                        borderColor: 'rgba(138, 43, 226, 1)', // Color de la línea Azul Violeta
                                        borderWidth: 2,
                                        showLine: true, // Muestra la línea que une los puntos
                                        fill: false, // Evita que se rellene el área debajo de la línea
                                        //tension: 0.4, // Suavizado de la línea
                                    }
                                    ]
                                },
                                options: {
                                    scales: {
                                        x: {
                                            type: 'linear',
                                            position: 'bottom',
                                            title: {
                                                display: true,
                                                text: 'X Axis'
                                            }
                                        },
                                        y: {
                                            title: {
                                                display: true,
                                                text: 'Y Axis'
                                            }
                                        }
                                    }
                                }
                            });

                            //Dibujo Grafico Nominal
                            if (myChart2) {
                                myChart2.destroy();
                            }

                            const ctx2 = document.getElementById('graficoNominal').getContext('2d');
                            myChart2 = new Chart(ctx2, {
                                type: 'scatter', // Tipo de gráfico
                                data: {
                                    datasets: [
                                        {
                                            label: 'GaliboInt', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaIntB[0], y: $scope.galiboNominal.listaIntH[0] },
                                                { x: $scope.galiboNominal.listaIntB[1], y: $scope.galiboNominal.listaIntH[1] },
                                                { x: $scope.galiboNominal.listaIntB[2], y: $scope.galiboNominal.listaIntH[2] },
                                                { x: $scope.galiboNominal.listaIntB[3], y: $scope.galiboNominal.listaIntH[3] },
                                                { x: $scope.galiboNominal.listaIntB[4], y: $scope.galiboNominal.listaIntH[4] },
                                                { x: $scope.galiboNominal.listaIntB[5], y: $scope.galiboNominal.listaIntH[5] },
                                                { x: $scope.galiboNominal.listaIntB[6], y: $scope.galiboNominal.listaIntH[6] },
                                                { x: $scope.galiboNominal.listaIntB[7], y: $scope.galiboNominal.listaIntH[7] },
                                                { x: $scope.galiboNominal.listaIntB[8], y: $scope.galiboNominal.listaIntH[8] }
                                            ],
                                            borderColor: 'rgba(255, 99, 132, 1)', // Color de la línea Rojo
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'GalibosExt', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaExtB[0], y: $scope.galiboNominal.listaExtH[0] },
                                                { x: $scope.galiboNominal.listaExtB[1], y: $scope.galiboNominal.listaExtH[1] },
                                                { x: $scope.galiboNominal.listaExtB[2], y: $scope.galiboNominal.listaExtH[2] },
                                                { x: $scope.galiboNominal.listaExtB[3], y: $scope.galiboNominal.listaExtH[3] },
                                                { x: $scope.galiboNominal.listaExtB[4], y: $scope.galiboNominal.listaExtH[4] },
                                                { x: $scope.galiboNominal.listaExtB[5], y: $scope.galiboNominal.listaExtH[5] },
                                                { x: $scope.galiboNominal.listaExtB[6], y: $scope.galiboNominal.listaExtH[6] },
                                                { x: $scope.galiboNominal.listaExtB[7], y: $scope.galiboNominal.listaExtH[7] },
                                                { x: $scope.galiboNominal.listaExtB[8], y: $scope.galiboNominal.listaExtH[8] }
                                            ],
                                            borderColor: 'rgba(54, 162, 235, 1)', // Color de la línea Azul
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'VmaxIntBmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaVmaxIntBmaxB[0], y: $scope.galiboNominal.listaVmaxIntBmaxH[0] },
                                                { x: $scope.galiboNominal.listaVmaxIntBmaxB[1], y: $scope.galiboNominal.listaVmaxIntBmaxH[1] },
                                                { x: $scope.galiboNominal.listaVmaxIntBmaxB[2], y: $scope.galiboNominal.listaVmaxIntBmaxH[2] },
                                                { x: $scope.galiboNominal.listaVmaxIntBmaxB[3], y: $scope.galiboNominal.listaVmaxIntBmaxH[3] },
                                                { x: $scope.galiboNominal.listaVmaxIntBmaxB[4], y: $scope.galiboNominal.listaVmaxIntBmaxH[4] },
                                                { x: $scope.galiboNominal.listaVmaxIntBmaxB[5], y: $scope.galiboNominal.listaVmaxIntBmaxH[5] },
                                                { x: $scope.galiboNominal.listaVmaxIntBmaxB[6], y: $scope.galiboNominal.listaVmaxIntBmaxH[6] }
                                            ],
                                            borderColor: 'rgba(255, 159, 64, 1)', // Color de la línea Naranja
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'VmaxIntHmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaVmaxIntHmaxB[0], y: $scope.galiboNominal.listaVmaxIntHmaxH[0] },
                                                { x: $scope.galiboNominal.listaVmaxIntHmaxB[1], y: $scope.galiboNominal.listaVmaxIntHmaxH[1] },
                                                { x: $scope.galiboNominal.listaVmaxIntHmaxB[2], y: $scope.galiboNominal.listaVmaxIntHmaxH[2] },
                                                { x: $scope.galiboNominal.listaVmaxIntHmaxB[3], y: $scope.galiboNominal.listaVmaxIntHmaxH[3] },
                                                { x: $scope.galiboNominal.listaVmaxIntHmaxB[4], y: $scope.galiboNominal.listaVmaxIntHmaxH[4] },
                                                { x: $scope.galiboNominal.listaVmaxIntHmaxB[5], y: $scope.galiboNominal.listaVmaxIntHmaxH[5] },
                                                { x: $scope.galiboNominal.listaVmaxIntHmaxB[6], y: $scope.galiboNominal.listaVmaxIntHmaxH[6] }
                                            ],
                                            borderColor: 'rgba(255, 206, 86, 1)', // Color de la línea Amarillo
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'VmaxExtBmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaVmaxExtBmaxB[0], y: $scope.galiboNominal.listaVmaxExtBmaxH[0] },
                                                { x: $scope.galiboNominal.listaVmaxExtBmaxB[1], y: $scope.galiboNominal.listaVmaxExtBmaxH[1] },
                                                { x: $scope.galiboNominal.listaVmaxExtBmaxB[2], y: $scope.galiboNominal.listaVmaxExtBmaxH[2] },
                                                { x: $scope.galiboNominal.listaVmaxExtBmaxB[3], y: $scope.galiboNominal.listaVmaxExtBmaxH[3] },
                                                { x: $scope.galiboNominal.listaVmaxExtBmaxB[4], y: $scope.galiboNominal.listaVmaxExtBmaxH[4] },
                                                { x: $scope.galiboNominal.listaVmaxExtBmaxB[5], y: $scope.galiboNominal.listaVmaxExtBmaxH[5] },
                                                { x: $scope.galiboNominal.listaVmaxExtBmaxB[6], y: $scope.galiboNominal.listaVmaxExtBmaxH[6] }
                                            ],
                                            borderColor: 'rgba(75, 192, 192, 1)', // Color de la línea Verde Claro
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'VmaxExtHmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaVmaxExtHmaxB[0], y: $scope.galiboNominal.listaVmaxExtHmaxH[0] },
                                                { x: $scope.galiboNominal.listaVmaxExtHmaxB[1], y: $scope.galiboNominal.listaVmaxExtHmaxH[1] },
                                                { x: $scope.galiboNominal.listaVmaxExtHmaxB[2], y: $scope.galiboNominal.listaVmaxExtHmaxH[2] },
                                                { x: $scope.galiboNominal.listaVmaxExtHmaxB[3], y: $scope.galiboNominal.listaVmaxExtHmaxH[3] },
                                                { x: $scope.galiboNominal.listaVmaxExtHmaxB[4], y: $scope.galiboNominal.listaVmaxExtHmaxH[4] },
                                                { x: $scope.galiboNominal.listaVmaxExtHmaxB[5], y: $scope.galiboNominal.listaVmaxExtHmaxH[5] },
                                                { x: $scope.galiboNominal.listaVmaxExtHmaxB[6], y: $scope.galiboNominal.listaVmaxExtHmaxH[6] }
                                            ],
                                            borderColor: 'rgba(201, 203, 207, 1)', // Color de la línea Gris
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'V0IntBmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaV0IntBmaxB[0], y: $scope.galiboNominal.listaV0IntBmaxH[0] },
                                                { x: $scope.galiboNominal.listaV0IntBmaxB[1], y: $scope.galiboNominal.listaV0IntBmaxH[1] },
                                                { x: $scope.galiboNominal.listaV0IntBmaxB[2], y: $scope.galiboNominal.listaV0IntBmaxH[2] },
                                                { x: $scope.galiboNominal.listaV0IntBmaxB[3], y: $scope.galiboNominal.listaV0IntBmaxH[3] },
                                                { x: $scope.galiboNominal.listaV0IntBmaxB[4], y: $scope.galiboNominal.listaV0IntBmaxH[4] },
                                                { x: $scope.galiboNominal.listaV0IntBmaxB[5], y: $scope.galiboNominal.listaV0IntBmaxH[5] },
                                                { x: $scope.galiboNominal.listaV0IntBmaxB[6], y: $scope.galiboNominal.listaV0IntBmaxH[6] }
                                            ],
                                            borderColor: 'rgba(255, 99, 71, 1)', // Color de la línea Tomate (Rojo claro)
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'V0IntHmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaV0IntHmaxB[0], y: $scope.galiboNominal.listaV0IntHmaxH[0] },
                                                { x: $scope.galiboNominal.listaV0IntHmaxB[1], y: $scope.galiboNominal.listaV0IntHmaxH[1] },
                                                { x: $scope.galiboNominal.listaV0IntHmaxB[2], y: $scope.galiboNominal.listaV0IntHmaxH[2] },
                                                { x: $scope.galiboNominal.listaV0IntHmaxB[3], y: $scope.galiboNominal.listaV0IntHmaxH[3] },
                                                { x: $scope.galiboNominal.listaV0IntHmaxB[4], y: $scope.galiboNominal.listaV0IntHmaxH[4] },
                                                { x: $scope.galiboNominal.listaV0IntHmaxB[5], y: $scope.galiboNominal.listaV0IntHmaxH[5] },
                                                { x: $scope.galiboNominal.listaV0IntHmaxB[6], y: $scope.galiboNominal.listaV0IntHmaxH[6] }
                                            ],
                                            borderColor: 'rgba(30, 144, 255, 1)', // Color de la línea Azul Dodger
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'V0ExtBmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaV0ExtBmaxB[0], y: $scope.galiboNominal.listaV0ExtBmaxH[0] },
                                                { x: $scope.galiboNominal.listaV0ExtBmaxB[1], y: $scope.galiboNominal.listaV0ExtBmaxH[1] },
                                                { x: $scope.galiboNominal.listaV0ExtBmaxB[2], y: $scope.galiboNominal.listaV0ExtBmaxH[2] },
                                                { x: $scope.galiboNominal.listaV0ExtBmaxB[3], y: $scope.galiboNominal.listaV0ExtBmaxH[3] },
                                                { x: $scope.galiboNominal.listaV0ExtBmaxB[4], y: $scope.galiboNominal.listaV0ExtBmaxH[4] },
                                                { x: $scope.galiboNominal.listaV0ExtBmaxB[5], y: $scope.galiboNominal.listaV0ExtBmaxH[5] },
                                                { x: $scope.galiboNominal.listaV0ExtBmaxB[6], y: $scope.galiboNominal.listaV0ExtBmaxH[6] }
                                            ],
                                            borderColor: 'rgba(60, 179, 113, 1)', // Color de la línea Verde marino medio
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        },
                                        {
                                            label: 'V0ExtHmax', // Etiqueta del conjunto de datos
                                            data: [
                                                { x: $scope.galiboNominal.listaV0ExtHmaxB[0], y: $scope.galiboNominal.listaV0ExtHmaxH[0] },
                                                { x: $scope.galiboNominal.listaV0ExtHmaxB[1], y: $scope.galiboNominal.listaV0ExtHmaxH[1] },
                                                { x: $scope.galiboNominal.listaV0ExtHmaxB[2], y: $scope.galiboNominal.listaV0ExtHmaxH[2] },
                                                { x: $scope.galiboNominal.listaV0ExtHmaxB[3], y: $scope.galiboNominal.listaV0ExtHmaxH[3] },
                                                { x: $scope.galiboNominal.listaV0ExtHmaxB[4], y: $scope.galiboNominal.listaV0ExtHmaxH[4] },
                                                { x: $scope.galiboNominal.listaV0ExtHmaxB[5], y: $scope.galiboNominal.listaV0ExtHmaxH[5] },
                                                { x: $scope.galiboNominal.listaV0ExtHmaxB[6], y: $scope.galiboNominal.listaV0ExtHmaxH[6] }
                                            ],
                                            borderColor: 'rgba(138, 43, 226, 1)', // Color de la línea Azul Violeta
                                            borderWidth: 2,
                                            showLine: true, // Muestra la línea que une los puntos
                                            fill: false, // Evita que se rellene el área debajo de la línea
                                            //tension: 0.4, // Suavizado de la línea
                                        }
                                    ]
                                },
                                options: {
                                    scales: {
                                        x: {
                                            type: 'linear',
                                            position: 'bottom',
                                            title: {
                                                display: true,
                                                text: 'X Axis'
                                            }
                                        },
                                        y: {
                                            title: {
                                                display: true,
                                                text: 'Y Axis'
                                            }
                                        }
                                    }
                                }
                            });
                        });

                    //alert('Cálculo de desplazamientos laterales verticales completado')
                    $scope.descargaActiva = false;
                    elemento.style.display = 'none';
                });
        }


        galibosService.getContornosInferiores()
            .then(function (response) {
                var data = response.data;
                $scope.contornosinferiores = data;
            });

        galibosService.getAnchosVia()
            .then(function (response) {
                var data = response.data;
                $scope.anchosvia = data;
            });

        galibosService.getPantografo()
            .then(function (response) {
                var data = response.data;
                $scope.pantografos = data;
            });

        galibosService.getTension()
            .then(function (response) {
                var data = response.data;
                $scope.tensiones = data;
            });

        galibosService.getEstadoBalasto()
            .then(function (response) {
                var data = response.data;
                $scope.estadosbalasto = data;
            });

        galibosService.getDatosParametrizables($scope.usuario)
            .then(function (response) {
                var data = response.data;
                //$scope.datosparametrizables = data;
                $scope.datosparametrizables = data;
            });

        galibosService.getRol($scope.usuario, $scope.InfraestructuraId)
            .then(function (response) {
                $scope.permiso = response.data;
            });

        $scope.pestanyavisible = 'datosentrada';

        $scope.indice = 0;


        $scope.volver = function () {
            $location.path('/infraestructura/' + $scope.InfraestructuraId);
            $rootScope.galibosUrl = true;
        }

        $scope.DatosEntradaCargar = function () {
            $scope.pestanyavisible = 'datosentrada';
        }

        $scope.DatosParametrizablesCargar = function () {
            $scope.pestanyavisible = 'datosparametrizables';
        }


        $scope.logout = function () {
            return authenticationService.logout();
        }


        $scope.limpiardatosentrada = function () {
            $scope.Contorno = null;
            $scope.AnchoVia = null;
            $scope.ContornoInferior = null;
            $scope.Pantografo = null;
            $scope.Tension = null;
            $scope.EstadoBalasto = null;
            $scope.R = null;
            $scope.D = null;
            $scope.I = null;
            $scope.TD = null;
            $scope.TN = null;
            $scope.Rv = null;
            $scope.Hcrmin = null;
            $scope.Hnez = null;
            $scope.Tq = null;
            $scope.tipoAnden = null;
            $scope.bordeInt = null;
            $scope.bordeExt = null;
            $scope.catenaria = null;
        }



        $scope.limpiardatosparametrizables = function () {
            $scope.datosparametrizables.lmax = null;
            $scope.datosparametrizables.L = null;
            $scope.datosparametrizables.D0 = null;
            $scope.datosparametrizables.I0 = null;
            $scope.datosparametrizables.hc0 = null;
            $scope.datosparametrizables.Tvia = null;
            $scope.datosparametrizables.ac = null;
            $scope.datosparametrizables.asusp = null;
            $scope.datosparametrizables.Kgen = null;
            $scope.datosparametrizables.Kh05 = null;
            $scope.datosparametrizables.M3balto = null;
            $scope.datosparametrizables.M3bbajo = null;
            $scope.datosparametrizables.M3halto = null;
            $scope.datosparametrizables.M3hbajo = null;
            $scope.datosparametrizables.pant_ho = null;
            $scope.datosparametrizables.pant_hu = null;
            $scope.datosparametrizables.pant_epo = null;
            $scope.datosparametrizables.pant_epu = null;
            $scope.datosparametrizables.pant_I0 = null;
            $scope.datosparametrizables.pant_Do = null;
            $scope.datosparametrizables.pant_cw = null;
            $scope.datosparametrizables.pant_hf = null;
        }



        $scope.descargarDXF = function () {

            var elemento = document.getElementById('loader-seguimiento');
            elemento.style.display = 'block';

            var formDataTexto = new FormData();
            formDataTexto.append("galiboVerticalHorizontal", JSON.stringify($scope.galiboVerticalHorizontal));
            formDataTexto.append("galiboNominal", JSON.stringify($scope.galiboNominal));
            formDataTexto.append("galiboAnden", JSON.stringify($scope.galiboAnden));

            galibosService.dibujarGraficos(formDataTexto)
                .then(function (response) {

                    var filename = "Grafico.zip";
                    var contentType = 'application/zip';

                    var blob = new Blob([response.data],
                        { type: contentType });

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) //IE
                        window.navigator.msSaveBlob(blob, filename);
                    else //Resto
                    {
                        var downloadLink = document.createElement("a");

                        var url = window.URL.createObjectURL(blob);
                        downloadLink.setAttribute("target", "_blank");
                        downloadLink.setAttribute("href", url);
                        downloadLink.setAttribute("download", filename);
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                        elemento.style.display = 'none';
                    }
                    //alert('Graficos Dibujados')
                })
        }

        $scope.verCategorias = function () {
            $rootScope.inspeccionUrl = false;
            $rootScope.parteUrl = false;
            $location.path('/categorias');
        };

        $scope.showCommaErrorR = false;
        $scope.showCommaErrorD = false;
        $scope.showCommaErrorI = false;
        $scope.showCommaErrorTD = false;
        $scope.showCommaErrorTN = false;
        $scope.showCommaErrorRv = false;
        $scope.showCommaErrorHcrmin = false;
        $scope.showCommaErrorHnez = false;
        $scope.showCommaErrorTq = false;
        $scope.showCommaErrorbordeInt = false;
        $scope.showCommaErrorbordeExt = false;
        $scope.showCommaErrorlmax = false;
        $scope.showCommaErrorD0 = false;
        $scope.showCommaErrorI0 = false;
        $scope.showCommaErrorhc0 = false;
        $scope.showCommaErrorTvia = false;
        $scope.showCommaErrorac = false;
        $scope.showCommaErrorasusp = false;
        $scope.showCommaErrorKgen = false;
        $scope.showCommaErrorKh05 = false;
        $scope.showCommaErrorM3balto = false;
        $scope.showCommaErrorM3bbajo = false;
        $scope.showCommaErrorM3halto = false;
        $scope.showCommaErrorM3hbajo = false;
        $scope.showCommaErrorpant_ho = false;
        $scope.showCommaErrorpant_hu = false;
        $scope.showCommaErrorpant_epo = false;
        $scope.showCommaErrorpant_epu = false;
        $scope.showCommaErrorpant_I0 = false;
        $scope.showCommaErrorpant_Do = false;
        $scope.showCommaErrorpant_cw = false;
        $scope.showCommaErrorpant_hf = false;

        $scope.checkForCommaR = function () {
            // Verifica si el valor contiene una coma
            if ($scope.R) {
                $scope.R = $scope.R.replace(',', '.');
            }
        };

        $scope.checkForCommaD = function () {
            // Verifica si el valor contiene una coma
            if ($scope.D) {
                $scope.D = $scope.D.replace(',', '.');
            }
        };

        $scope.checkForCommaI = function () {
            // Verifica si el valor contiene una coma
            if ($scope.I) {
                $scope.I = $scope.I.replace(',', '.');
            }
        };


        $scope.checkForCommaTD = function () {
            // Verifica si el valor contiene una coma
            if ($scope.TD) {
                $scope.TD = $scope.TD.replace(',', '.');
            }
        };

        $scope.checkForCommaTN = function () {
            // Verifica si el valor contiene una coma
            if ($scope.TN) {
                $scope.TN = $scope.TN.replace(',', '.');
            }
        };

        $scope.checkForCommaRv = function () {
            // Verifica si el valor contiene una coma
            if ($scope.Rv) {
                $scope.Rv = $scope.Rv.replace(',', '.');
            }
        };

        $scope.checkForCommaHcrmin = function () {
            // Verifica si el valor contiene una coma
            if ($scope.Hcrmin) {
                $scope.Hcrmin = $scope.Hcrmin.replace(',', '.');
            }
        };

        $scope.checkForCommaHnez = function () {
            // Verifica si el valor contiene una coma
            if ($scope.Hnez) {
                $scope.Hnez = $scope.Hnez.replace(',', '.');
            }
        };

        $scope.checkForCommaTq = function () {
            // Verifica si el valor contiene una coma
            if ($scope.Tq) {
                $scope.Tq = $scope.Tq.replace(',', '.');
            }
        };

        $scope.checkForCommabordeInt = function () {
            // Verifica si el valor contiene una coma
            if ($scope.bordeInt) {
                $scope.bordeInt = $scope.bordeInt.replace(',', '.');
            }
        };

        $scope.checkForCommabordeExt = function () {
            // Verifica si el valor contiene una coma
            if ($scope.bordeExt) {
                $scope.bordeExt = $scope.bordeExt.replace(',', '.');
            }
        };

        $scope.checkForCommalmax = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.lmax) {
                $scope.datosparametrizables.lmax = $scope.datosparametrizables.lmax.replace(',', '.');
            }
        };

        $scope.checkForCommaL = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.L) {
                $scope.datosparametrizables.L = $scope.datosparametrizables.L.replace(',', '.');
            }
        };

        $scope.checkForCommaD0 = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.D0) {
                $scope.datosparametrizables.D0 = $scope.datosparametrizables.D0.replace(',', '.');
            }
        };

        $scope.checkForCommaI0 = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.I0) {
                $scope.datosparametrizables.I0 = $scope.datosparametrizables.I0.replace(',', '.');
            }
        };

        $scope.checkForCommahc0 = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.hc0) {
                $scope.datosparametrizables.hc0 = $scope.datosparametrizables.hc0.replace(',', '.');
            }
        };

        $scope.checkForCommaTvia = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.Tvia) {
                $scope.datosparametrizables.Tvia = $scope.datosparametrizables.Tvia.replace(',', '.');
            }
        };

        $scope.checkForCommaac = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.ac) {
                $scope.datosparametrizables.ac = $scope.datosparametrizables.ac.replace(',', '.');
            }
        };

        $scope.checkForCommaasusp = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.asusp) {
                $scope.datosparametrizables.asusp = $scope.datosparametrizables.asusp.replace(',', '.');
            }
        };

        $scope.checkForCommaKgen = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.Kgen) {
                $scope.datosparametrizables.Kgen = $scope.datosparametrizables.Kgen.replace(',', '.');
            }
        };

        $scope.checkForCommaKh05 = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.Kh05) {
                $scope.datosparametrizables.Kh05 = $scope.datosparametrizables.Kh05.replace(',', '.');
            }
        };

        $scope.checkForCommaM3balto = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.M3balto) {
                $scope.M3balto = $scope.M3balto.replace(',', '.');
            }
        };

        $scope.checkForCommaM3bbajo = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.M3bbajo) {
                $scope.datosparametrizables.M3bbajo = $scope.datosparametrizables.M3bbajo.replace(',', '.');
            }
        };

        $scope.checkForCommaM3halto = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.M3halto) {
                $scope.datosparametrizables.M3halto = $scope.datosparametrizables.M3halto.replace(',', '.');
            }
        };

        $scope.checkForCommaM3hbajo = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.M3hbajo) {
                $scope.datosparametrizables.M3hbajo = $scope.datosparametrizables.M3hbajo.replace(',', '.');
            }
        };

        $scope.checkForCommapant_ho = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_ho) {
                $scope.datosparametrizables.pant_ho = $scope.datosparametrizables.pant_ho.replace(',', '.');
            }
        };

        $scope.checkForCommapant_hu = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_hu) {
                $scope.datosparametrizables.pant_hu = $scope.datosparametrizables.pant_hu.replace(',', '.');
            }
        };

        $scope.checkForCommapant_epo = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_epo) {
                $scope.datosparametrizables.pant_epo = $scope.datosparametrizables.pant_epo.replace(',', '.');
            }
        };

        $scope.checkForCommapant_epu = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_epu) {
                $scope.datosparametrizables.pant_epu = $scope.datosparametrizables.pant_epu.replace(',', '.');
            }
        };

        $scope.checkForCommapant_I0 = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_I0) {
                $scope.datosparametrizables.pant_I0 = $scope.datosparametrizables.pant_I0.replace(',', '.');
            }
        };

        $scope.checkForCommapant_Do = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_Do) {
                $scope.datosparametrizables.pant_Do = $scope.datosparametrizables.pant_Do.replace(',', '.');
            }
        };


        $scope.checkForCommapant_cw = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_cw) {
                $scope.datosparametrizables.pant_cw = $scope.datosparametrizables.pant_cw.replace(',', '.');
            }
        };

        $scope.checkForCommapant_hf = function () {
            // Verifica si el valor contiene una coma
            if ($scope.datosparametrizables.pant_hf) {
                $scope.datosparametrizables.pant_hf = $scope.datosparametrizables.pant_hf.replace(',', '.');
            }
        };

        $scope.guadarDatosBD = function () {
            galibosService.guadarDatosBD($scope.datosparametrizables, $scope.usuario)
                .then(function (response) {
                    $scope.datosparametrizables = response.data;
                })
        };
    }
]);